import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=dae535ca&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dae535ca')) {
      api.createRecord('dae535ca', component.options)
    } else {
      api.reload('dae535ca', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=dae535ca&", function () {
      api.rerender('dae535ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2jSMq9dKqInS3/JS/comp/IncreaseNumber.vue"
export default component.exports